<template>
  <div class="relative block rounded-full">
  </div>
</template>

<script>
export default {
  name: 'CircleIcon',
};
</script>

<style lang="scss" scoped>
</style>
